export const AD_MEDIA = 'adMedia';
export const LOGIN_MEDIA = 'loginMedia';
export const ADD_SHARE_AD_ACCOUNT = 'addShareAdAccount';
export const EDIT_SHARE_AD_ACCOUNT = 'editShareAdAccount';
export const CHOOSE_MEDIA = 'chooseMedia';
export const LINK_OFF_AD_ACCOUNT = 'linkoffAdAccount';
export const LINK_AD_ACCOUNT = 'linkAdAccount';
export const LINK_AD_ACCOUNT_GOOGLE = 'linkAdAccountGoogle';
export const LINK_AD_ACCOUNT_LINE = 'linkAdAccountLine';
export const LINK_AD_ACCOUNT_TABOOLA = 'linkAdAccountTaboola';
export const LINK_AD_ACCOUNT_ANIMATION = 'linkAdAccountAnimation';